import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";
import { SoggettoGiuridico } from '../models';


class DataTablesResponse {
    data: SoggettoGiuridico[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Injectable({
    providedIn: "root"
})
export class SoggettoGiuridicoService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}SoggettiGiuridici/`;
    private publicApiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob_public}SoggettiGiuridici/`;
    constructor(private http: HttpClient) { }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<DataTablesResponse>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    insert(s: SoggettoGiuridico) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: SoggettoGiuridico) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    getAll(){
        return this.http.get<any>(`${this.apiUrl}`);
    }
    getSoggettiAttuatori(ruoloId: number){
        return this.http.get<any>(`${this.publicApiUrl}ruolo/attuatore?ruoloId=${ruoloId}`);
    }
    save(s:SoggettoGiuridico){
        if (s.id)return this.update(s);
        return this.insert(s);
    }

}
